export default __webpack_public_path__ + "static/media/eere_logo_horiz_green_reversed.4e961690.jpg";